import ConnectionDetector from 'components/helper/Connection/Detector';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as connectionAC } from 'store/connection';

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doSetOnline: connectionAC.doSetOnline,
			doSetOffline: connectionAC.doSetOffline,
		},
		dispatch
	);
};

export default connect(void 0, mapDispatchToProps)(ConnectionDetector as any);
